"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-CheckmarkMedium" },
      _react2.default.createElement("path", { d: "M4.5 10a1.023 1.023 0 0 1-.8-.384l-2.488-3a1 1 0 0 1 1.577-1.233L4.5 7.376l4.712-5.991a1 1 0 1 1 1.576 1.23l-5.511 7A.977.977 0 0 1 4.5 10z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M6 14a1 1 0 0 1-.788-.385l-4-5a1 1 0 1 1 1.576-1.23L6 11.376l7.213-8.991a1 1 0 1 1 1.576 1.231l-8 10A1 1 0 0 1 6 14z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'CheckmarkMedium';
exports.default = WrappedIcon;

